import tns from '@/lib/tiny-slider/tiny-slider.js';

document.addEventListener(
    "DOMContentLoaded", () => {
        var iconElems = document.querySelectorAll('.introduction-row, .amenities-row, .room-imagery-row');
        for (var i = 0; i < iconElems.length; i++) {
            var waypoint = new Waypoint({
                element: iconElems[i],
                handler: function () {
                    this.element.classList.add('reveal');
                },
                offset: '75%'
            });
        }


        var roomGalleryWrap = document.querySelector('.room-gallery-wrap');
        var roomItemGallery = roomGalleryWrap.querySelector('.room-gallery');

        var rlaCarousel = tns({
            container: roomItemGallery,
            items: 1,
            slideBy: 1,
            autoplay: false,
            controls: true,
            controlsPosition: true,
            nav: false,
            speed: 800,
            controlsContainer: roomGalleryWrap.querySelector('.tns-controls')
        });

    }
);
